import type { RequestConfig } from '@customTypes/index';
import type { WorkingConditionDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type PostClubProfileWorkConditionRequest = {
  clubId: string;
  data: WorkingConditionDto;
};

export type PostClubProfileWorkConditionParams =
  RequestConfig<PostClubProfileWorkConditionRequest>;

export const postClubProfileWorkCondition = async ({
  params,
  config
}: PostClubProfileWorkConditionParams) =>
  api.post(
    `/api/ClubProfile/working-conditions/${params.clubId}`,
    params.data,
    config
  );
